import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { withRouter } from "react-router-dom";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem 0",
  },
  heading: {
    marginBottom: "1rem",
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "70%",
  },
}));

const CoachingProgramModal = (props) => {
  const { isOpen, onClose, setProgramFlag } = props;
  const classes = useStyles();

  return (
    <React.Fragment>
      <Dialog
        PaperProps={{
          style: { borderRadius: "20px", width: "35%" },
        }}
        fullWidth={true}
        maxWidth={"md"}
        open={isOpen}
        onClose={onClose}
        aria-labelledby="max-width-dialog-title"
      >
        <div className={classes.root}>
          <div>
            <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
              Coaching program successfully created
            </Typography>
          </div>
          <div className={classes.heading}>
            <FormControlLabel
              control={<Checkbox name="" color="primary" />}
              label={
                <Typography variant="h2">
                  Add this program to master templates
                </Typography>
              }
            />
          </div>
          <div className={classes.footer}>
            <Button
              disableElevation
              onClick={() => {
                if (props?.action == "editMaster") {
                  props.history.push("/admin/setup");
                } else {
                  setProgramFlag(false);
                  setTimeout(() => {
                    setProgramFlag(true);
                  }, 300);
                }
              }}
              variant="contained"
              color="secondary"
            >
              Done
            </Button>
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default withRouter(CoachingProgramModal);
